import React from 'react';
import styled from 'styled-components';
import { Text } from '../Typography';
import Required from '../Required';
import theme from '../theme';

export type LabelWrapperProps = {
  label?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  className?: string;
  position?: 'before' | 'after';
  children?: React.ReactNode;
  dataCy?: string;
};

const LabelWrapper = React.forwardRef<HTMLDivElement, LabelWrapperProps>(
  (
    {
      label,
      error,
      required,
      className,
      children,
      position = 'before',
      dataCy,
    },
    ref,
  ) => {
    const errorComponent =
      error && typeof error !== 'boolean' ? (
        <StyledDanger block type="danger">
          {error}
        </StyledDanger>
      ) : null;

    return (
      <StyledLabel
        $error={Boolean(error)}
        className={className}
        data-cy={dataCy}
        ref={ref}
      >
        {typeof label === 'string' ? (
          <Text strong block>
            {label} {required && <Required />}
          </Text>
        ) : (
          label
        )}
        {position === 'before' && errorComponent}
        {children}
        {position === 'after' && errorComponent}
      </StyledLabel>
    );
  },
);

export const StyledLabel = styled.div<{ $error: boolean }>`
  position: relative;
  display: block;
  > * {
    width: 100%;
  }
  && {
    .ant-input,
    .ant-radio-button-wrapper,
    .ant-picker,
    .ant-select-selector {
      ${({ $error }) =>
        $error && `border: 1px solid ${theme.getColor('danger')}`};
    }
  }
`;

export const StyledDanger = styled(Text)`
  line-height: 1;
  font-size: 1.2rem;
`;

export default LabelWrapper;
